var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: _vm.title,
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          class: _vm.method === "view" ? "readonly" : "",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            "label-width": "120px",
            disabled: _vm.method === "view",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.doSubmit()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("el-divider", { attrs: { "content-position": "left" } }, [
            _c("i", { staticClass: "el-icon-lock" }),
            _vm._v(" 登录信息"),
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "账号",
                        prop: "loginName",
                        rules: [
                          {
                            required: true,
                            message: "登录名不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.loginName,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "loginName", $$v)
                          },
                          expression: "inputForm.loginName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "密码:",
                        prop: "newPassword",
                        rules: _vm.inputForm.id
                          ? []
                          : [
                              {
                                required: true,
                                message: "密码不能为空",
                                trigger: "blur",
                              },
                            ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "50",
                          placeholder: "若不修改，请留空",
                          "show-password": "",
                        },
                        model: {
                          value: _vm.inputForm.newPassword,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "newPassword", $$v)
                          },
                          expression: "inputForm.newPassword",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "确认密码",
                        prop: "confirmNewPassword",
                        rules: _vm.inputForm.id
                          ? [{ validator: _vm.validatePass2, trigger: "blur" }]
                          : [
                              {
                                required: true,
                                message: "确认密码不能为空",
                                trigger: "blur",
                              },
                              { validator: _vm.validatePass2, trigger: "blur" },
                            ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          maxlength: "50",
                          placeholder: "",
                          "show-password": "",
                        },
                        model: {
                          value: _vm.inputForm.confirmNewPassword,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "confirmNewPassword", $$v)
                          },
                          expression: "inputForm.confirmNewPassword",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "是否允许登录",
                        prop: "loginFlag",
                        rules: [
                          {
                            required: true,
                            message: "必须选择",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.inputForm.loginFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "loginFlag", $$v)
                            },
                            expression: "inputForm.loginFlag",
                          },
                        },
                        _vm._l(
                          _vm.$dictUtils.getDictList("yes_no"),
                          function (item) {
                            return _c(
                              "el-radio",
                              { key: item.id, attrs: { label: item.value } },
                              [_vm._v(_vm._s(item.label))]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider", { attrs: { "content-position": "left" } }, [
            _c("i", { staticClass: "el-icon-user" }),
            _vm._v(" 身份信息"),
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "姓名",
                        rules: [
                          {
                            required: true,
                            message: "姓名不能为空",
                            trigger: "blur",
                          },
                        ],
                        prop: "name",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "name", $$v)
                          },
                          expression: "inputForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "手机",
                        prop: "mobile",
                        rules: [
                          {
                            validator: _vm.validator.isMobile,
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "mobile", $$v)
                          },
                          expression: "inputForm.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "电话",
                        prop: "phone",
                        rules: [
                          { validator: _vm.validator.isPhone, trigger: "blur" },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "phone", $$v)
                          },
                          expression: "inputForm.phone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "邮箱",
                        prop: "email",
                        rules: [
                          {
                            type: "email",
                            message: "请输入正确的邮箱地址",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "email", $$v)
                          },
                          expression: "inputForm.email",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-divider", { attrs: { "content-position": "left" } }, [
            _c("i", { staticClass: "el-icon-postcard" }),
            _vm._v(" 岗位信息"),
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "companyDTO.id",
                        rules: [
                          {
                            required: true,
                            message: "公司不能为空",
                            trigger: "blur",
                          },
                        ],
                        label: "公司",
                      },
                    },
                    [
                      _c("SelectTree", {
                        ref: "companyTree",
                        attrs: {
                          props: {
                            value: "id", // ID字段名
                            label: "name", // 显示名称
                            children: "children", // 子级字段名
                          },
                          url: "/sys/office/treeData?type=1",
                          value: _vm.inputForm.companyDTO.id,
                          clearable: true,
                          accordion: true,
                        },
                        on: {
                          getValue: function (value) {
                            _vm.inputForm.companyDTO.id = value
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "officeDTO.id",
                        rules: [
                          {
                            required: true,
                            message: "部门不能为空",
                            trigger: "blur",
                          },
                        ],
                        label: "部门",
                      },
                    },
                    [
                      _c("SelectTree", {
                        ref: "officeTree",
                        attrs: {
                          props: {
                            value: "id", // ID字段名
                            label: "name", // 显示名称
                            children: "children", // 子级字段名
                          },
                          url: "/sys/office/treeData?type=2",
                          value: _vm.inputForm.officeDTO.id,
                          clearable: true,
                          accordion: true,
                        },
                        on: {
                          getValue: function (value) {
                            _vm.inputForm.officeDTO.id = value
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "工号",
                        prop: "no",
                        rules: [
                          {
                            required: true,
                            message: "工号不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "50", placeholder: "" },
                        model: {
                          value: _vm.inputForm.no,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "no", $$v)
                          },
                          expression: "inputForm.no",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "岗位", prop: "postIdList" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { multiple: "", placeholder: "请选择" },
                          model: {
                            value: _vm.inputForm.postIdList,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "postIdList", $$v)
                            },
                            expression: "inputForm.postIdList",
                          },
                        },
                        _vm._l(_vm.postList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "角色",
                        prop: "roleIdList",
                        rules: [
                          {
                            required: true,
                            message: "角色不能为空",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { multiple: "", placeholder: "请选择" },
                          model: {
                            value: _vm.inputForm.roleIdList,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "roleIdList", $$v)
                            },
                            expression: "inputForm.roleIdList",
                          },
                        },
                        _vm._l(_vm.roleList, function (role) {
                          return _c("el-option", {
                            key: role.id,
                            attrs: { label: role.name, value: role.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remarks" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "200",
                          placeholder: "",
                        },
                        model: {
                          value: _vm.inputForm.remarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "remarks", $$v)
                          },
                          expression: "inputForm.remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _vm.method != "view"
            ? _c(
                "el-button",
                {
                  directives: [
                    { name: "noMoreClick", rawName: "v-noMoreClick" },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.doSubmit()
                    },
                  },
                },
                [_vm._v("确定")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }